import { render, staticRenderFns } from "./ListTrainingAssociations.vue?vue&type=template&id=20a2e24a"
import script from "./ListTrainingAssociations.vue?vue&type=script&lang=js"
export * from "./ListTrainingAssociations.vue?vue&type=script&lang=js"
import style0 from "./ListTrainingAssociations.vue?vue&type=style&index=0&id=20a2e24a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports